
import React from 'react';
import { StatsSections } from './components/StatsSections';
import { calculateTeamGoals } from './utils/goalCalculations';
import { calculateTeamCards } from './utils/cardCalculations';
import { calculateTeamCorners } from './utils/cornerCalculations';
import { FoulsStatsSection } from './components/FoulsStatsSection';
import {
  calculateMatchResults,
  calculateOverUnderStats,
  calculateFoulsStats,
  calculateHtFtStats
} from './utils/statsCalculations';

interface LeagueStatsSummaryProps {
  data: any[];
}

const LeagueStatsSummary: React.FC<LeagueStatsSummaryProps> = ({ data }) => {
  const matchResults = calculateMatchResults(data);
  
  const overUnderStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, undefined, threshold)
  }));

  const overUnderHtStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, undefined, threshold, true)
  }));

  const overUnderHomeStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, true, threshold)
  }));

  const overUnderAwayStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, false, threshold)
  }));

  const overUnderHtHomeStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, true, threshold, true)
  }));

  const overUnderHtAwayStats = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5].map(threshold => ({
    threshold,
    ...calculateOverUnderStats(data, false, threshold, true)
  }));

  const foulsStats = calculateFoulsStats(data);
  const htFtStats = calculateHtFtStats(data);

  const overallGoalsStats = calculateTeamGoals(data);
  const homeGoalsStats = calculateTeamGoals(data, true);
  const awayGoalsStats = calculateTeamGoals(data, false);

  const overallCardStats = calculateTeamCards(data);
  const homeCardStats = calculateTeamCards(data, true);
  const awayCardStats = calculateTeamCards(data, false);

  const overallCornerStats = calculateTeamCorners(data);
  const homeCornerStats = calculateTeamCorners(data, true);
  const awayCornerStats = calculateTeamCorners(data, false);

  return (
    <div className="space-y-8">
      <StatsSections
        matchResults={matchResults}
        foulsStats={foulsStats}
        htFtStats={htFtStats}
        overUnderStats={overUnderStats}
        overUnderHomeStats={overUnderHomeStats}
        overUnderAwayStats={overUnderAwayStats}
        overUnderHtStats={overUnderHtStats}
        overUnderHtHomeStats={overUnderHtHomeStats}
        overUnderHtAwayStats={overUnderHtAwayStats}
        overallGoalsStats={overallGoalsStats}
        homeGoalsStats={homeGoalsStats}
        awayGoalsStats={awayGoalsStats}
        overallCardStats={overallCardStats}
        homeCardStats={homeCardStats}
        awayCardStats={awayCardStats}
        overallCornerStats={overallCornerStats}
        homeCornerStats={homeCornerStats}
        awayCornerStats={awayCornerStats}
      />
      <FoulsStatsSection matches={data} />
    </div>
  );
};

export default LeagueStatsSummary;
